import {
    OpenGraphMetaTag,
    TwitterMetaTags,
    use3rdParties,
    useHTMLAttrsLang,
    useCanonicalURL,
    useOpenGraphMetaTags,
    useSeoMeta,
    useTranslation,
    useTwitterMetaTags,
} from '#imports';

export const useSeo = () => {
    const {t} = useTranslation();

    use3rdParties();

    const title = t('sitemap.meta.title.v2');
    const description = t('sitemap.meta.description.v2');
    useSeoMeta({
        title,
        description,
        robots: 'noindex,follow',
    });
    useTwitterMetaTags(new TwitterMetaTags({card: 'summary', title, description, t}));
    useOpenGraphMetaTags(new OpenGraphMetaTag({title, description, t}));

    useHTMLAttrsLang();
    useCanonicalURL();
};
